import { apiClient } from "@/services/api/axiosClient";
import { ApiResponse } from "@/shared/types/api.types";
import {
  EnrollInPlanPayload,
  EnrollInPlanResponseData,
  PowerbillEligibleResponse,
  PowerbillUtility,
} from "../modal/powerBill.types.ts";
import { logger } from "@/lib/logger";
export const powerbillService = {
  async getEletricityEligible(
    zip: string,
    state: string,
    stateName: string | ""
  ): Promise<ApiResponse<PowerbillEligibleResponse>> {
    const { data } = await apiClient.get<ApiResponse<PowerbillEligibleResponse>>(
      `/api/energybot-service/api/v2/energy/utilities/eligible?zip=${zip}&state_name=${stateName}&state=${state}`
    );
    logger.info("getEletricityEligible() | data - ", data);
    return data;
  },

  async getEletricityPlans(
    zip: string,
    utilityName: string,
    term: number | number[],
    propertyType: string
  ): Promise<ApiResponse<PowerbillUtility>> {
    const serializedTerm = Array.isArray(term) ? term.join(",") : term || "";
    const { data } = await apiClient.get<ApiResponse<PowerbillUtility>>(
      `/api/energybot-service/api/v2/energy/plans?zip=${zip}&supplier_name=${utilityName}&term=${serializedTerm}&property_type=${propertyType}`
    );
    logger.info("getEletricityPlans() | data - ", data);
    return data;
  },

  async enrollInPlan(payload: EnrollInPlanPayload): Promise<ApiResponse<EnrollInPlanResponseData>> {
    const { data } = await apiClient.post<ApiResponse<EnrollInPlanResponseData>>(
      `api/energybot-service/api/v2/energy/enroll`,
      payload
    );
    logger.info("enrollInPlan() | data - ", data);
    return data;
  },
};
